import { render, staticRenderFns } from "./review-lender.vue?vue&type=template&id=a1a4b7b2&"
import script from "./review-lender.vue?vue&type=script&lang=ts&"
export * from "./review-lender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports